import type { SVGProps } from 'react';
const SvgTreeStand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path
      fillRule="evenodd"
      d="m22.346 15.045-.887-5.188a2.22 2.22 0 0 0-2.18-1.928 2.237 2.237 0 0 0-2.198 2.584l1.562 8.987a2.22 2.22 0 0 0 2.14 1.929H27.9a2.256 2.256 0 0 0 2.314-2.257 2.237 2.237 0 0 0-2.314-2.237h-3.336a2.256 2.256 0 0 1-2.218-1.89"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M30.214 25.768H14.786V6H9v27h5.786v-4.34h15.428z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTreeStand;
